module.exports = __webpack_public_path__ + "static/media/42ed5148acd91b1c8cb763db3e0d478a.1fa1a139.mp4";